export default __webpack_public_path__ + "static/media/foreign-cover-3.39b88644.jpg";